import { Grid, PopoverOrigin } from '@mui/material';
import {
  HSpacer,
  RoutalPalette,
  RoutalSelect,
  RoutalSelectMultiSelectOption,
  RoutalSelectMultiSelectOptions,
  RoutalSelectProps,
  RoutalText as Text,
} from '@nx-smartmonkey/ui';
import moment from 'moment-timezone';
import React, { useState } from 'react';
import { CheckmarkIcon } from '../assets/svg/CheckmarkIcon';
import { commonTimeZones } from '../constants/CommonTimeZones';

interface TimeZoneSelectorProps extends Partial<RoutalSelectProps> {
  onChangeTimeZone: (value: string) => void;
  timeZone: string;
  listItemStyles?: React.CSSProperties;
  popoverProps?: {
    options: RoutalSelectMultiSelectOptions;
    maxHeight?: string;
    anchor?: {
      anchorOrigin?: PopoverOrigin;
      transformOrigin?: PopoverOrigin;
    };
    onOpen?: (event: any) => void;
    onBlur?: (event: any) => void;
  };
}

function formatTime(timeZone: string): string {
  const offset = moment.tz(timeZone).utcOffset();
  const hours = Math.floor(Math.abs(offset) / 60);
  const minutes = Math.abs(offset) % 60;
  const sign = offset >= 0 ? `+` : `-`;
  const formattedOffset = `GMT ${sign} ${String(hours).padStart(2, `0`)}:${String(minutes).padStart(2, `0`)}`;

  return `(${formattedOffset})`;
}

export const TimeZoneSelector = (props: TimeZoneSelectorProps) => {
  const settingsTimeZones = React.useMemo(() => {
    return commonTimeZones.map((value) => ({
      value,
      label: formatTime(value),
    }));
  }, []);

  const [timezone, setTimezone] = useState<string>(props.timeZone ?? `UTC`);

  const formattedTimeZone = timezone.replace(/_/g, ` `);
  return (
    <RoutalSelect
      {...props}
      id="time-zone-select"
      popoverProps={{
        options: settingsTimeZones.map(
          (setting: { value: string; label: string }): RoutalSelectMultiSelectOption => ({
            key: setting.value,
            listItemStyles: props.listItemStyles,
            content: (
              <Grid
                style={{
                  width: `100%`,
                  display: `flex`,
                  flexDirection: `row`,
                  flexWrap: `nowrap`,
                  alignItems: `center`,
                  justifyContent: `space-between`,
                }}
              >
                <Grid style={{ display: `flex`, flexDirection: `row`, flexWrap: `nowrap` }}>
                  <Text style={{ textAlign: `start`, cursor: `pointer` }}>{setting.value.replace(/_/g, ` `)}</Text>
                  <HSpacer small />
                  <Text style={{ cursor: `pointer`, color: RoutalPalette.secondary00 }}>{setting.label}</Text>
                </Grid>
                {timezone === setting.value && <CheckmarkIcon />}
              </Grid>
            ),
            onClick: () => {
              // updateProject({ timeZone: setting.value });
              setTimezone(setting.value);
              props.onChangeTimeZone(setting.value as string);
            },
          })
        ),
      }}
      {...props.popoverProps}
    >
      <Grid style={{ width: `100%`, display: `flex`, flexDirection: `row`, flexWrap: `nowrap`, alignItems: `center` }}>
        <Text style={{ textAlign: `start`, cursor: `pointer` }}>{formattedTimeZone}</Text>
        <HSpacer small />
        <Text style={{ cursor: `pointer`, color: RoutalPalette.secondary00 }}>{formatTime(timezone)}</Text>
      </Grid>
    </RoutalSelect>
  );
};
